import { DSPostShortWithAuthor, DSTaxonomiedList } from 'shared-definitions/types'
import { ApiPaginatedCategory } from 'data-source/types.wp'
import {
  onePostWithAuthorMapper,
  OnePostWithAuthorMapperOpts,
} from 'data-source/mappers/onePostWithAuthorMapper'
import { paginationMapper } from 'data-source/mappers/paginationMapper'

export function paginatedCategoryMapper(
  input: ApiPaginatedCategory,
  opts: OnePostWithAuthorMapperOpts
): DSTaxonomiedList<DSPostShortWithAuthor> {
  return {
    ...paginationMapper(input.content),
    resource: 'paginated-list',
    taxonomies: Object.keys(input.tax).map(key => ({
      name: key,
      value: input.tax[key],
    })),
    items: input.content.posts.map(i => onePostWithAuthorMapper(i, opts)),
  }
}
